// React is disabled, serving pure HTML from public/index.html
console.log("Serving pure HTML. React rendering has been disabled.");
